import { MutableRefObject, useLayoutEffect } from 'react';

const useHorizontalDragScroll = (ref: MutableRefObject<HTMLElement | null>, draggableClassName: string, tableId: string) => {
    useLayoutEffect(() => {
        const slider = document.querySelector<HTMLElement>(`#${tableId}`);
        if (!slider) {
            return;
        }

        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;

        const hasOverflow = () => slider.scrollWidth > slider.clientWidth;

        const onMouseDown = (e: MouseEvent) => {
            if (!hasOverflow()) return;

            isDragging = true;
            slider.classList.add(draggableClassName.replace('.', ''));
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        };

        const onMouseMove = (e: MouseEvent) => {
            if (!isDragging) return;

            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = x - startX;
            slider.scrollLeft = scrollLeft - walk;
        };

        const onMouseUp = () => {
            isDragging = false;
            slider.classList.remove(draggableClassName.replace('.', ''));
        };

        slider.style.cursor = 'grab';
        slider.addEventListener('mousedown', onMouseDown);
        slider.addEventListener('mousemove', onMouseMove);
        slider.addEventListener('mouseup', onMouseUp);
        slider.addEventListener('mouseleave', onMouseUp);

        return () => {
            slider.removeEventListener('mousedown', onMouseDown);
            slider.removeEventListener('mousemove', onMouseMove);
            slider.removeEventListener('mouseup', onMouseUp);
            slider.removeEventListener('mouseleave', onMouseUp);
        };
    }, [ref.current, draggableClassName, tableId]);
};

export default useHorizontalDragScroll;
